import React from "react";
import Icon, { IconProps } from "./Icon";

const DotsVerticalIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
    </Icon>
  );
};

export default DotsVerticalIcon;
